import { AfterViewInit, Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { AbstractFormComponent } from '../../../../../shared/crud/component/form.component';
import { CustomerPaymentForm } from './payment.form';
import { AdminUrlBuilder } from '../../../../../shared/admin/api/admin-url-builder';

@Component({
  selector: 'admin-customer-payment',
  templateUrl: './payment.component.html',
  styleUrls: [ './payment.component.scss' ]
})
export class AdminCustomerPaymentComponent extends AbstractFormComponent implements OnInit, AfterViewInit {

  constructor(formBuilder: CustomerPaymentForm,
              httpClient: HttpClient,
              toastrService: ToastrService,
              urlBuilder: AdminUrlBuilder,
              router: Router,
              route: ActivatedRoute) {
    super(formBuilder, httpClient, toastrService, router, route, urlBuilder);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.formMode = 'update';
    this.populate().subscribe();
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
  }

  protected getUrl(): string {
    return `/customer/${this.route.parent.snapshot.params.id}`;
  }

  protected onSubmit(response: any): void {
    this.toastrService.success('Saved');
  }

  reset() {
    this.populate().subscribe();
  }
}
